import {createSelector} from 'reselect';
import {List} from 'immutable';
import type {FieldType} from '@packages/systems/dynamo/records/Field';
import {NON_CONFIGURABLE_FIELD_SLUGS} from '@packages/systems/dynamo/utils/CollectionFieldUtils';
import {isCommerceCollection} from '@packages/systems/commerce/utils/CommerceCollectionUtils';
import {isSupportedField} from './fieldUtils';
import {getCollectionNameFromVariable} from '@packages/systems/flows/shared';
import {DesignerStores} from '@packages/systems/designer/flux';

export {getIcon} from './getIcon';
export {
  initializeField,
  adjustFieldValue,
  isSupportedField,
  isSupportedCustomField,
  supportedFieldsBySlug,
  getFieldBySlug,
  getCustomSlugs,
  getBasicSlugs,
  BASIC_FIELDS,
} from './fieldUtils';

export const selectCMSCollections = createSelector(
  (state: DesignerStores) => state.CollectionStore.collections,
  (collections) =>
    collections.filter((collection) => !isCommerceCollection(collection))
);
export type BlockTypes = // Blocks
  | 'Create'
  | 'Delete'
  | 'Update' // Triggers
  | 'Lookup'
  | 'Updated';
export {getCollectionNameFromVariable};
export type Compatibility =
  | 'incompatible-required'
  | 'compatible'
  | 'incompatible-optional';

/**
 * Determines whether a collection's fields are compatible with Logic Flows
 */
export const getCollectionFieldCompatibility = (
  fields: List<FieldType>
): Compatibility =>
  // @ts-expect-error - TS2345 - Argument of type '(acc: "compatible" | undefined, field: FieldType | undefined) => "incompatible-required" | "compatible" | "incompatible-optional" | undefined' is not assignable to parameter of type '(reduction?: "compatible" | undefined, value?: FieldType | undefined, key?: number | undefined, iter?: Iterable<number, FieldType> | undefined) => "compatible"'.
  fields.reduce((acc, field) => {
    if (NON_CONFIGURABLE_FIELD_SLUGS.hasOwnProperty(field.slug)) return acc;
    if (isSupportedField(field)) return acc;
    // Disable collections that have at least 1 required field that is not compatible
    // @ts-expect-error - TS2367 - This comparison appears to be unintentional because the types '"compatible" | undefined' and '"incompatible-required"' have no overlap.
    if (acc === 'incompatible-required') return acc;
    if (field.required) return 'incompatible-required';
    // Show a warning note for collections that have optional incompatible fields
    return 'incompatible-optional';
  }, 'compatible');
